module.exports = __webpack_public_path__ + "img/screen.7faf02f2.png";